import { api } from './client'
import type { ReviewMap, ShopfrontApplyResponse, UUID } from '@/types/api'

export const reviewMapApi = {
  get: async (jobId: UUID): Promise<ReviewMap> =>
    (await api.get(`/jobs/${jobId}/review-map`)).data,

  overlayBlob: async (jobId: UUID): Promise<Blob> =>
    (await api.get(`/jobs/${jobId}/overlay.png`, { responseType: 'blob' })).data,

  reviewPreviewBlob: async (jobId: UUID): Promise<Blob> =>
    (
      await api.get(`/jobs/${jobId}/review-preview.png`, {
        responseType: 'blob',
        timeout: 120_000,
      })
    ).data,

  /** 手动画店铺范围（米坐标 GeoJSON Polygon）→ 后端按此过滤空间。 */
  applyShopfront: async (
    jobId: UUID,
    polygon: { type: 'Polygon'; coordinates: number[][][] },
  ): Promise<ShopfrontApplyResponse> =>
    (await api.post(`/jobs/${jobId}/shopfront`, { polygon })).data,
}
